import { css, Theme } from '@emotion/react'

export const avatar = css`
  width: 28px;
  height: 28px;
  border-radius: 50%;
`

export const index = (theme: Theme) => css`
  display: flex;
  width: 45px;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 38px;
  background: ${theme.backgrounds.backgroundFive};
  font-weight: 500;
`

export const button = css`
  margin-top: 24px;
`

export const longText = (theme: Theme) => css`
  max-height: 40px;
  width: 140px;
  overflow-y: scroll;
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 500;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const description = css`
  width: 270px;
`

export const editIcon = (theme: Theme) => css`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  width: 36px;
  height: 36px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 10px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const iconPlus = (theme: Theme) => css`
  color: ${theme.colors.blue};
`

export const container = css`
  max-width: 750px;
  margin: 0 auto;
`

export const tableTitle = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  font-weight: 400;
  margin-bottom: 12px;
  margin-top: 24px;
`

export const table = (theme: Theme) => css`
  padding: 14px;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  gap: 12px;
  margin-bottom: 24px;
  max-height: 627px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 30px;
    background: ${theme.backgrounds.backgroundTwo};
    width: 6px;
  }

  > div > div {
    border: 1px solid ${theme.backgrounds.backgroundOne};
    background: ${theme.backgrounds.backgroundFive};
    box-shadow: ${theme.boxShadows.small};
  }
`

export const renderItem = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 6px;
  align-items: center;
`

export const block = css`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`
